export default __webpack_public_path__ + "static/media/idris.b86774af.jpg";